import { reactive, computed, onBeforeMount } from '@vue/composition-api'
import * as _ from 'lodash'
import { PRODUCT_STATUS, PRODUCT_STATUS_NAME } from '@/util/constants'
import { addServiceTemplateTableParams } from '@/logic/common/CommonService'
import { processWithGettingPaymentMethodInfo } from '@/logic/common/CommonPaymentMethod'

export const ServiceLicensePurchaseInput = (context) => {
  const store = context.root.$store
  const router = context.root.$router
  const { contractPack, purchase } = store.state

  onBeforeMount(() => {
    store
      .dispatch('purchase/resetAllState')
      .then(() => {
        store
          .dispatch('contract/getContractData')
          .then(() => {
            store.dispatch('purchase/setDefaultPayment')
          })
        store
          .dispatch('contractPack/getPackageData')
          .then(() => {
            store
              .dispatch('purchase/setDefaultLists')
              .then(() => {
                state.loaded = true
              })
          })

      })

    // お支払い方法欄の初期表示
    paymentMethod.init()
  })

  const unsignedNewPackageProduct = computed(() => {
    const products = store.getters['contractPack/unsignedNewPackageProduct']
    // 販売停止になっているものを除外する
    const list = _.reject(products, product => product.package_master_status === 4 || product.product_master_status === 6)

    // 商品リストにテンプレート処理用の追加パラメータを設定
    addServiceTemplateTableParams(list)

    return list
  })
  const signedNewPackageProduct = computed(() => {
    const products = store.getters['contractPack/signedNewPackageProduct']
    // 販売停止になっているものを除外する
    const list = _.reject(products, product => product.package_master_status === 4 || product.product_master_status === 6)

    // 商品リストにテンプレート処理用の追加パラメータを設定
    addServiceTemplateTableParams(list)

    return list
  })
  const purchaseList = computed(() => store.getters['purchase/getPurchaseList'])
  const action = reactive({
    selectBoxOnChange: (selected, index) => store.dispatch('purchase/changePurchase', { index, selected }),
    reset: index => store.dispatch('purchase/resetPurchase', index),
    buy: (index, first) => {
      const selected = first.value ?? 0
      store.dispatch('purchase/changePurchase', { index, selected })
      store.dispatch('purchase/buyPurchase', index)
    },
    cancel: index => {
      store
        .dispatch('contractPack/setSelectProduct', purchase.lists[index])
        .then(() => {
          state.visibleCancelInput = true
        })
    },
    submit: () => {
      store.dispatch('common/showLoading')
      store
        .dispatch('purchase/setCalculation')
        .then(async () => {
          await store.dispatch('purchase/purchaseConfirm')
        })
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    },
    closeConfirm: () => {
      store.dispatch('common/showLoading')
      store
        .dispatch('purchase/closeConfirm')
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    },
    submitConfirm: () => {
      store.dispatch('common/showLoading')
      store
        .dispatch('purchase/submitConfirm')
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    },
    closeComplete: () => {
      store
        .dispatch('purchase/closeComplete')
        .then(() => {
          router.push({ name: 'PCService' })
        })
    }
  })

  const productStatus = index => {
    // const thisProduct = signedNewPackageProduct.value[index]
    const thisProduct = purchase.lists[index]
    const thisPurchase = purchase.lists[index].purchase
    const thisEdited = purchase.lists[index].edited
    const thisBeforeNum = thisProduct.license_number
    const thisAfterNum = thisProduct.license_number + thisPurchase
    // const basicProductIndex = _.findIndex(signedNewPackageProduct.value, product => product.package_name === thisProduct.package_name && product.classification === 2)
    // const basicProduct = signedNewPackageProduct.value[basicProductIndex]
    const basicProductIndex = _.findIndex(purchase.lists, product => product.package_name === thisProduct.package_name && product.classification === 2)
    const basicProduct = purchase.lists[basicProductIndex]
    const basicEdited = purchase.lists[basicProductIndex].edited
    const basicPurchase = purchase.lists[basicProductIndex].purchase
    const basicBeforeNum = basicProduct.license_number
    const basicAfterNum = basicProduct.license_number + basicPurchase
    return {
      isBasic: thisProduct.classification === 2,
      isSigned: PRODUCT_STATUS.SIGNED_PRODUCT.includes(thisProduct.status),
      isSignedAndEdit: PRODUCT_STATUS.SIGNED_PRODUCT.includes(thisProduct.status) && thisEdited,
      isSignedAndNoEdit: PRODUCT_STATUS.SIGNED_PRODUCT.includes(thisProduct.status) && !thisEdited,
      isUnsigned: PRODUCT_STATUS.UNSIGNED_PRODUCT.includes(thisProduct.status),
      isUnsignedAndEdit: PRODUCT_STATUS.UNSIGNED_PRODUCT.includes(thisProduct.status) && thisEdited,
      isUnsignedNoEdit: PRODUCT_STATUS.UNSIGNED_PRODUCT.includes(thisProduct.status) && !thisEdited,
      isEdited: thisEdited,
      isCancel: PRODUCT_STATUS.CANCEL_PRODUCT.includes(thisProduct.status) || thisProduct.cancel_license_number > 0,
      isNothing: PRODUCT_STATUS.UNSIGNED_PRODUCT.includes(thisProduct.status) && !thisEdited,
      beforeNum: thisBeforeNum,
      afterNum: thisAfterNum,
      name: thisProduct.name,
      basicProductIndex: basicProductIndex,
      basicProduct: basicProduct,
      // basicIsCancel: PRODUCT_STATUS.CANCEL_PACKAGE === basicProduct.status || basicProduct.cancel_license_number === basicProduct.license_number,
      basicIsCancel: PRODUCT_STATUS.CANCEL_PACKAGE === basicProduct.status || (basicProduct.license_number > 0 && basicProduct.cancel_license_number === basicProduct.license_number),
      basicIsNothing: PRODUCT_STATUS.UNSIGNED_PRODUCT.includes(basicProduct.status) && !basicEdited,
      basicAfterNum: basicAfterNum,
      basicIsSigned: PRODUCT_STATUS.SIGNED_PRODUCT.includes(basicProduct.status)
    }
  }

  // 各部品の表示
  const visible = reactive({
    // basicProductIndex: index => ,
    // 未契約商品の場合、購入ボタンを表示
    buy: index => {
      const { isBasic, isUnsignedNoEdit, basicIsCancel, basicIsNothing, basicAfterNum } = productStatus(index)
      return (isBasic)
        ? isUnsignedNoEdit
        : isUnsignedNoEdit && !basicIsCancel && !basicIsNothing && basicAfterNum > 0
    },
    // キャンセルのある商品の場合、解除予約の取り消しボタンを表示
    cancel: index => {
      const { isBasic, isCancel, basicIsCancel, basicIsNothing } = productStatus(index)
      return (isBasic)
        ? isCancel
        : isCancel && !basicIsCancel && !basicIsNothing
    },
    // 契約中、かつ、解除予約が入っていない商品、もしくは購入ボタンを押した商品の場合、個数選択のセレクトボックスを表示
    select: index => {
      const { isBasic, isEdited, isSigned, isCancel, basicIsCancel, basicIsNothing, basicAfterNum } = productStatus(index)
      // (productStatus(index).isSigned && !productStatus(index).isSigned) || productStatus(index).isEdited
      return (isBasic)
        ? (isSigned && !isCancel) || isEdited
        : (isSigned && !isCancel && !basicIsCancel && !basicIsNothing && basicAfterNum > 0) || (isEdited && basicAfterNum > 0)
    },
    // 編集がおこなわれた商品の場合リセットボタンを表示する
    reset: index => {
      const { isEdited } = productStatus(index)
      return isEdited
    },
    note: index => {
      const message = {
        parentCancel: 'パッケージが解約予約済のため、ライセンス追加ができません。',
        parentNothing: param => `${param}を購入していないため、購入できません。`,
        cancel: '解約予約済のため、ライセンス追加ができません。',
        signed: (param1) => `契約中のライセンス数 ${param1}`,
        edited: (param1, param2) => `契約中のライセンス数 ${param1} > ${param2}`,
        no: ''
      }
      return (() => {
        const ps = productStatus(index)
        if (ps.isBasic) {
          // 基本商品
          if (ps.isCancel) return message.cancel
          else if (ps.isSignedAndNoEdit) return message.signed(ps.beforeNum)
          else if (ps.isSignedAndEdit) return message.edited(ps.beforeNum, ps.afterNum)
          else if (ps.isUnsignedAndNoEdit) return message.no
          else if (ps.isUnsignedAndEdit) return message.edited(ps.beforeNum, ps.afterNum)
          else return message.no
        } else {
          // オプション商品
          if (ps.basicIsCancel) return message.parentCancel
          else if (ps.basicIsNothing || ps.basicAfterNum <= 0) return message.parentNothing(ps.basicProduct.name)
          else if (ps.basicIsSigned || !ps.basicIsNothing) {
            if (ps.isCancel) return message.cancel
            else if (ps.isSignedAndNoEdit) return message.signed(ps.beforeNum)
            else if (ps.isSignedAndEdit) return message.edited(ps.beforeNum, ps.afterNum)
            else if (ps.isUnsignedAndNoEdit) return message.no
            else if (ps.isUnsignedAndEdit) return message.edited(ps.beforeNum, ps.afterNum)
          } else return message.nol
        }
      })()
    }
  })

  // お支払方法関連
  const paymentMethod = reactive({
    // お支払方法ID
    paymentMethodID: 0,
    // お支払方法名
    paymentMethodName: '',

    /**
     * お支払い方法欄の初期表示
     */
    init: () => {

      const callback = (paymentMethodID, paymentMethodName) => {
        paymentMethod.paymentMethodID = paymentMethodID
        paymentMethod.paymentMethodName = paymentMethodName
      }
      // 利用者の契約情報を表示するために使用するAPIへのリクエスト処理し、
      // その後、引数で渡したコールバック処理を行う
      processWithGettingPaymentMethodInfo(callback, false)
    }
  })

  const state = reactive({
    loaded: false,
    visibleCancelInput: false,
    visiblePurchaseConfirm: false,
    visiblePurchaseComplete: false
  })

  return {
    PRODUCT_STATUS_NAME,
    purchase,
    purchaseList,
    contractPack,
    signedNewPackageProduct,
    unsignedNewPackageProduct,
    action,
    visible,
    paymentMethod,
    state
  }
}
